import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { Mercaderia, DetalleIngreso } from 'src/app/model/index.model';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { CbMercaderia2Component } from '../../combo/cb-mercaderia-2/cb-mercaderia-2.component';
import { DetalleIngresoService } from 'src/app/service/index.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FrmDetalleIngresoComponent } from '../../formulario/frm-detalle-ingreso/frm-detalle-ingreso.component';

@Component({
  selector: 'app-detalle-compra',
  templateUrl: './detalle-compra.component.html',
  styleUrls: ['./detalle-compra.component.css']
})
export class DetalleCompraComponent implements OnInit {

  @ViewChild(CbMercaderia2Component) gr: CbMercaderia2Component;

  @ViewChild("cant", { static: false }) cant: ElementRef;
  @ViewChild("pre", { static: false }) prec: ElementRef;
  @ViewChild("pre2", { static: false }) prec2: ElementRef;

  @ViewChild("close", { static: false }) close: ElementRef;



  @Output() compra = new EventEmitter<DetalleIngreso[]>();

  cantidad: number = 0;
  precio: number = 0;
  precio2: number = 0;
  mercaderia: Mercaderia;
  detalle: DetalleIngreso[];
  item: DetalleIngreso;

  constructor(private wsdldi: DetalleIngresoService,
    private modalService: NgbModal,
  ) {
    this.detalle = [];
    this.mercaderia = new Mercaderia()
  }

  ngOnInit() {
  }

  select(item: DetalleIngreso) {
    this.item = new DetalleIngreso();
    this.item = item;
    this.editarDetalle(this.item)
  }

  @Input()
  set items(event: DetalleIngreso[]) {
    if (event) {
      this.detalle = event;
    }
  }

  itemSel(event: Mercaderia) {

    if (event) {
      this.mercaderia = event;
      this.precio2 = event.precioLis;
      this.precio = event.precioCom;
      this.cant.nativeElement.select()
    } else {
      UturuncoUtils.showToas("no encontro datos", "info")
    }

  }

  pase() {
    this.prec.nativeElement.focus()
  }
  pase2() {
    this.prec2.nativeElement.focus()
  }

  addRow() {

    if (this.mercaderia.id == undefined || this.cantidad <= 0 || this.precio <= 0) {
      UturuncoUtils.showToas("debe seleccionar un mercaderia y agregar una cantidad", "error")
      return;
    }
    let control = this.detalle.find((e) => e.mercaderia.id == this.mercaderia.id);

    if (control == undefined) {
      let det = new DetalleIngreso();
      det.cantidad = this.cantidad;
      det.mercaderia = this.mercaderia;
      det.precio = this.precio;
      det.precio2 = this.precio2;
      det.usuario = JSON.parse(UturuncoUtils.getSession("user"));
      this.detalle.unshift(det);
      this.compra.emit(this.detalle)
      this.mercaderia = new Mercaderia();
      this.cantidad = 1;
      this.gr.foco(true);

    } else {
      UturuncoUtils.showToas("Este elemento ya existe en tu lista", "info");
    }

  }

  async remove(det) {
    if (det.id > 0) {
      await this.wsdldi.doDelete(det.id).then();
    }
    this.detalle = this.detalle.filter(e => e.mercaderia.id != det.mercaderia.id);
    this.compra.emit(this.detalle)

  }

  setResult(event) {
    this.close.nativeElement.click();
  }

  editarDetalle(det: any) {
    const modalRef = this.modalService.open(
      FrmDetalleIngresoComponent,
      {
        size: 'md',
        centered: true,
        backdrop: 'static',    // evita cerrar al clickear afuera (como tenías data-backdrop="static")
        keyboard: true         // permite cerrar con ESC
      }
    );

    // Pasamos el detalle seleccionado al componente del modal
    modalRef.componentInstance.select = { ...det }; // clona para no modificar el original directamente

    // Escuchamos el resultado cuando el modal se cierra
    modalRef.result.then(
      (resultado) => {
        // El usuario guardó → actualizamos la fila en la tabla
        console.log('Detalle editado y guardado:', resultado);
        // Aquí puedes actualizar this.detalle con el nuevo valor si lo necesitas
        // Ejemplo: const index = this.detalle.findIndex(d => d === det);
        // if (index !== -1) this.detalle[index] = resultado;
        // o simplemente recargar la lista completa si viene del backend
      },
      (reason) => {
        console.log('Edición cancelada o descartada:', reason);
        // No hacemos nada o mostramos mensaje si quieres
      }
    );
  }

}
